/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Rating_Mandy_EversoleInputs */

const en_onboarding_rating_mandy_eversole = /** @type {(inputs: Onboarding_Rating_Mandy_EversoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LOVE this! I'm a grad student full time who also works full time and drives long distances. This is a LIFESAVER!`)
};

const es_onboarding_rating_mandy_eversole = /** @type {(inputs: Onboarding_Rating_Mandy_EversoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Me ENCANTA! Soy estudiante de posgrado a tiempo completo que también trabaja a tiempo completo y conduce largas distancias. ¡Esto es un SALVAVIDAS!`)
};

/**
* | output |
* | --- |
* | "LOVE this! I'm a grad student full time who also works full time and drives long distances. This is a LIFESAVER!" |
*
* @param {Onboarding_Rating_Mandy_EversoleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_rating_mandy_eversole = /** @type {((inputs?: Onboarding_Rating_Mandy_EversoleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Rating_Mandy_EversoleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_rating_mandy_eversole(inputs)
	return en_onboarding_rating_mandy_eversole(inputs)
});